const axios = require('axios')

export default class UnifiedLoginService {
  constructor() {
    this.pollId = 0;
    this.pollTimer = 10000;
  }

  getCloudRunUrl() {
    const e = location.hostname === 'localhost' ? 'local' : process.env.__environment__;

    switch(e) {
      case 'int':
        return 'https://login-service-int.skykit.com';
      case 'qa':
        return 'https://login-service-qa.skykit.com';
      case 'stage':
        return 'https://login-service-stage.skykit.com';
      case 'prod':
        return 'https://login-service.skykit.com';
      case 'local':
        return 'http://localhost:8081';
    }
  }

  async validateSessionCookie() {
    const devFlag = location.hostname === 'localhost' ? '?dev=true' : '';

    const response = await axios({
      method: 'POST',
      url: `${this.getCloudRunUrl()}/api/verifySession${devFlag}`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-HEADER': ('; '+document.cookie).split('; XSRF-TOKEN=').pop().split(';').shift()
      },
      withCredentials: true
    });

    return response.data;
  }

  async onPolling(cb, errCb) {
    clearTimeout(this.pollId);

    this.pollId = setTimeout(async () => {
      try {
        const data = await this.validateSessionCookie();
        this.onPolling(cb, errCb);

        if (typeof cb === 'function') {
          cb(data);
        }
      } catch (err) {
        
        if (typeof errCb === 'function') {
          errCb(err);
        }

        clearTimeout(this.pollId);
      }
    }, this.pollTimer);
  }

  stopPolling() {
    clearTimeout(this.pollId);
  }

  async clearSession() {
    try {
      const devFlag = location.hostname === 'localhost' ? '?dev=true' : '';

      await fetch(`${this.getCloudRunUrl()}/api/sessionLogout${devFlag}`, {
        method: 'POST',
        credentials: 'include',
      })
    } catch(err) {
      console.error(`session logout failed`);
    }
  }
}